import { z } from 'zod';
import { ProductInfoSchema } from './product-info';

// form validation rules
export const OrderItemSchema = z.object({
  product: ProductInfoSchema,
  // All four are `omitempty` on the Go side, so a zero quantity arrives as an
  // absent key rather than a 0 — which is why unitsOf/casesOf below fall
  // through on undefined rather than on a falsy value.
  suggested_cases: z.number().int().gt(-1).optional(),
  cases: z.number().int().gt(-1).optional(),
  suggested_units: z.number().int().gt(-1).optional(),
  units: z.number().int().gt(-1).optional(),
});

export type OrderItem = z.infer<typeof OrderItemSchema>;

export function unitsOf(orderItem: OrderItem) {
  if (orderItem.units !== undefined) {
    return orderItem.units;
  }

  if (orderItem.suggested_units !== undefined) {
    return orderItem.suggested_units;
  }

  return 0;
}

export function casesOf(orderItem: OrderItem) {
  if (orderItem.cases !== undefined) {
    return orderItem.cases;
  }

  if (orderItem.suggested_cases !== undefined) {
    return orderItem.suggested_cases;
  }

  return 0;
}

export function totalUnits(orderItem: OrderItem) {
  return casesOf(orderItem) * orderItem.product.case_qty + unitsOf(orderItem);
}

export function totalCost(orderItem: OrderItem) {
  return totalUnits(orderItem) * orderItem.product.last_cost;
}
